// Shared timestamp formatter (PR 8a.2.1): every stored timestamp is UTC, but
// the backend serialises Mongo datetimes as NAIVE ISO strings (no 'Z'/offset
// — motor returns naive UTC and serialize_doc calls .isoformat() on it), so
// `new Date(value)` in the browser parses the digits as LOCAL time and
// toLocaleString() shows raw UTC ("12:46" for a 13:46 BST action). Display
// only: parse naive strings as the UTC they are, then render in Europe/London
// (named zone, not a fixed offset, so GMT/BST switches are automatic).
// Storage, transport and comparisons stay UTC and untouched.

// A trailing 'Z' or ±HH:MM / ±HHMM offset after the time part means the
// string already carries its timezone (e.g. FastAPI-encoded aware datetimes
// end in "+00:00") — pass those through rather than double-marking them.
const HAS_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;

export default function formatTimestamp(value) {
  if (!value) return '—';
  let date;
  if (typeof value === 'string' && value.includes('T') && !HAS_ZONE.test(value)) {
    date = new Date(`${value}Z`);
  } else {
    date = new Date(value);
  }
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('en-GB', { timeZone: 'Europe/London' });
}
